export default __webpack_public_path__ + "b646716ad2d181ea59d184176adb41b1.svg";